
import "./style.css";

import logo from "./img.png";

const Checkout = () => {
  return (
    <div>
      
    <div className="contact">
     
      <img alt="logo" className="img" src={logo}/>
      <h2 align="center">Check Out Page</h2>

      <h2 align="center">Still Under Construction...

    
      </h2>
      
      <h6  align="center">We Will Activate This Process Soon</h6>
      <h6  align="center"><a align="center" className="link" href="/">Go To Main Page</a>
      </h6>
     
          </div>
          </div>
  );
};

export default Checkout;
